import { render } from "./ProgressionsAccordion.vue?vue&type=template&id=aade10c0&scoped=true"
import script from "./ProgressionsAccordion.vue?vue&type=script&lang=js"
export * from "./ProgressionsAccordion.vue?vue&type=script&lang=js"

import "./ProgressionsAccordion.vue?vue&type=style&index=0&id=aade10c0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aade10c0"]])

export default __exports__